import React, { useRef } from "react";
import { ArrowRight, Play, ChevronLeft, ChevronRight } from "lucide-react";
import { articles } from "../mock";

const ArticleCard = ({ article }) => (
  <div className="relative flex-shrink-0 w-[280px] md:w-[320px] aspect-[4/5] rounded-2xl overflow-hidden cursor-pointer group">
    <img
      src={article.image}
      alt={article.title}
      className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
    <div className="absolute inset-x-0 bottom-0 p-5">
      <h3 className="text-white font-semibold text-[17px] leading-tight mb-4">
        {article.title}
      </h3>
      <div className="w-9 h-9 bg-[#2D6A4F] rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
        <Play
          className="w-4 h-4 text-white fill-white ml-0.5"
        />
      </div>
    </div>
  </div>
);

const ResourceHub = () => {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === "left" ? -340 : 340,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="bg-[#F3F2EE] py-20 md:py-28 px-4 md:px-8 overflow-hidden">
      <div className="max-w-[1300px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16 mb-10">
          <div className="lg:w-[420px] flex-shrink-0">
            <div className="inline-flex items-center gap-2 bg-[#2D6A4F] text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6">
              <span>🧠</span> Knowledge Hub
            </div>
            <h2
              className="text-[40px] md:text-[48px] leading-[1.05] font-semibold text-[#0E0E10] tracking-tight mb-5"
              style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
            >
              Need some{" "}
              <span className="italic font-normal">answers</span> now?
            </h2>
            <p className="text-[16px] text-[#4A4A4D] leading-relaxed mb-7">
              Browse our knowledge hub for expert articles, videos and
              resources on CIS payroll, compliance and construction industry
              regulations.
            </p>
            <a
              href="#resources"
              className="inline-flex items-center gap-3 bg-[#0E0E10] text-white pl-6 pr-2 py-2 rounded-full hover:bg-[#6B7C61] transition-colors group"
            >
              <span className="font-medium">Visit Resource Hub</span>
              <span className="bg-[#2D6A4F] text-white w-8 h-8 rounded-full flex items-center justify-center group-hover:translate-x-1 transition-transform">
                <ArrowRight className="w-4 h-4" />
              </span>
            </a>
          </div>

          <div className="flex-1 min-w-0 relative">
            <div
              ref={scrollRef}
              className="flex gap-4 md:gap-5 overflow-x-auto scrollbar-hide pb-2 pr-4"
              style={{ scrollbarWidth: "none" }}
            >
              {articles.map((a, i) => (
                <ArticleCard key={i} article={a} />
              ))}
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={() => scroll("left")}
            className="w-11 h-11 rounded-full border border-[#0E0E10]/20 flex items-center justify-center hover:bg-[#0E0E10] hover:text-white transition-colors"
            aria-label="Previous"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={() => scroll("right")}
            className="w-11 h-11 rounded-full border border-[#0E0E10]/20 flex items-center justify-center hover:bg-[#0E0E10] hover:text-white transition-colors"
            aria-label="Next"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ResourceHub;
